import * as yup from "yup";

const schema = yup.object().shape({
  username: yup.string().required().label("Email"),
  password: yup.string().required().label("Password"),
});

export default schema;
